import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.418 4.157a8 8 0 0 0 0 15.686","key":"svg-0"}],["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconMoon2 = createReactComponent('outline', 'moon-2', 'Moon2', __iconNode);

export default IconMoon2;